import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import MainBanner from './../components/main-banner/MainBanner';
import TypeOfContract from '../components/type-of-contract/TypeOfContract';
import LeasingRate from '../components/leasing-rate/LeasingRate';
import { getApiLink } from './../services/getApiLink';
import { getMinimumMonths } from './../services/getMinimumMonths';
import { convertPrice } from './../services/convertPrice';
import phpFile from './../sessiondata.php'
import { percentageCalc } from '../services/percentageCalc';
import ProviderInfo from '../components/provider-info/ProviderInfo';
import { getAmortization } from './../services/getAmortization';
import LeasingItems from '../components/leasing-items/LeasingItems';
import { getTypeName } from '../services/getTypeName';
import StepBar from '../components/steps-bar/StepsBar';
import SendEmailCalc from '../components/send-calc-email/SendCalcEmail';
import LineSeperator from '../components/line-seperator/LineSeperator';
import Benefits from '../components/benefits/Benefits';
import getDataFromUrl from './../services/getDataFromUrl';

const ShopHomePageContainer = ( props ) => {
    let [ rate4, setRate4 ] = useState('');
    let [ rate12, setRate12 ] = useState('');
    let [ fileData, setFileData ] = useState([{tables: '', seller: ''}]);
    let [ calculateRate, setCalculateRate ] = useState(false);
    let [ activeRate4, setActiveRate4 ] = useState(true);
    let [ showTax, setShowTax ] = useState(true);
    let [ forceValidate, setForceValidate ] = useState(false);
    let [ forceValidateItems, setForceValidateItems ] = useState(false);
    let [ errors, setErrors ] = useState(true);
    let [ retryCalc, setRetryCalc ] = useState(false);
    let [ clickedButton, setClickedButton ] = useState(0);
    let [ minimumMonth, setMinimumMonth ] = useState(false);
    let [ changesInCalculator, setChangesInCalculator ] = useState(false); // check changes in calc
    let [ load, setLoad ] = useState(false);
    let [ updateType, setUpdateType ] = useState(0);
    let [ disableSelectItems, setDisableSelectItems ] = useState(false);
    let [ resetEmailCalc, setResetEmailCalc ] = useState(0);

    const dispatch = useDispatch()

    let products                  = useSelector(state => state.products)
    let leasingTime               = useSelector(state => state.leasingTime)
    let initialCharge             = useSelector(state => state.initialCharge)
    let productPrice              = useSelector(state => state.productPrice)
    let activeContract            = useSelector(state => state.selectedLease)
    let tax                       = useSelector(state => state.tax)
    let repurchase                = useSelector(state => state.repurchase)
    let provider                  = useSelector(state => state.provider)
    let minThreshold        = useSelector(state => state.minThreshold)
    let maxThreshold        = useSelector(state => state.maxThreshold)
    
    useEffect(() => {
        if ( products.length > 0 ) {
            if ( activeContract != 'nowoczesny') {
                dispatch({ type: 'MIN_MONTH_CHANGE', value: getMinimumMonths(products) })
            }
        }
    }, [products])

    //load php file
    let addPhpScript = () => {
        const script = document.createElement("script");
        script.src = phpFile;
        script.type = "text/javascript";
        document.head.appendChild(script);
    }

    // on First load 
    useEffect(() => {
        if ( !load ) {
            const loadInit = async () => {
                await dispatch({ type: 'INIT_STEPS' })
                await dispatch({ type: 'STEPS_CHANGE', value: 1 })
                await addPhpScript(); //only for shops
                await wait(2000)
                if ( !productPrice || productPrice === '0 zł') {
                    await loadDataFromSession();
                }
                await recalculatePriceEnd();
            }
            loadInit();

            setLoad(true);
        } 
    }, [load])
        let loadDataFromSession = async () => {
            let session = window.AppConfig;
            let k = getDataFromUrl("k");
            await dispatch({ type: 'LEASING_TIME_CHANGE', value: session ? session.defaultMonths.toString() :  '18' })
            await dispatch({ type: 'INITIAL_CHARGE_CHANGE', value: session ? session.initial +'%': '0%' })
            await dispatch({ type: 'MIN_INITIAL_CHARGE_CHANGE', value: session ? session.minInitial +'%': '0%' })
            await dispatch({ type: 'MAX_INITIAL_CHARGE_CHANGE', value: session ? session.maxInitial +'%': '30%' })
            await dispatch({ type: 'PRODUCT_PRICE_CHANGE', value: session ? session.value : '0.00'})
            await dispatch({ type: 'TAX_CHANGE', value: session ? convertPrice(session.price.toString() ) + " zł" : '300,00 zł'})
            await dispatch({ type: 'SELECTED_LEASE_CHANGE', value: session ? session.selectedLeaseType : 'nowoczesny' })
            await dispatch({ type: 'MODERN_LEASE_CHANGE', value: session ? session.enableModernLease : true })
            await dispatch({ type: 'TRADITIONAL_LEASE_CHANGE', value: session ? session.enableTraditionalLease : true })
            await dispatch({ type: 'MIN_MONTH_CHANGE', value: session ? session.minMonths : '18' })
            await dispatch({ type: 'MAX_MONTH_CHANGE', value: session ? session.maxMonths : '48' })            
            await dispatch({ type: 'ALLOW_FORM_CHANGE', value: session ? session.allowForm : true })
            await dispatch({ type: 'LEGAL_FORM_CHANGE', value: session ? session.legalForm : true })            
            await dispatch({ type: 'PROVIDER_CHANGE', value: session ? session.provider : true });
            await dispatch({ type: 'PROVIDER_NAME_CHANGE', value: session ? session.providerName : '' });
            await dispatch({ type: 'PROVIDER_POSTAL_CHANGE', value: session ? session.providerPostal : '' });
            await dispatch({ type: 'CALL_NUMBER_CHANGE', value: k == "dok" ? '61 / 872 37 51' : '61 872 37 16' })
            await dispatch({ type: 'IS_SHOP_CHANGE', value: true })
            await dispatch({ type: 'COURIER_CHANGE', value: session ? session.courier : true })
            await dispatch({ type: 'URL_FORM_FINISH_CHANGE', value: session ? session.urlFormFinish : window.location.host })
            await dispatch({ type: 'URL_FORM_FINISH_EXTERNAL_CHANGE', value: session ? session.urlFormFinishExternal : window.location.host })
            await dispatch({ type: 'RATE_CHANGE', value: session ? session.rate : ['kwartalna', 'miesieczna'] })
            await dispatch({ type: 'RATE_FREQUENCY_CHANGE', value: session ? session.rateFrequency : 'kwartalnie'})
            await dispatch({ type: 'SHOW_ESIGN_CHANGE', value: session ? session.showEsign : false})
            await dispatch({ type: 'SHOW_ESIGN_MAX_PRICE_CHANGE', value: session ? session.showEsignMaxPrice : 1000})
            await dispatch({ type: 'SHOW_TAX_CHANGE', value: session ? session.startTax : true})
            await dispatch({ type: 'MIN_THRESHOLD_CHANGE', value: session ? session.minThreshold : 20000.00 })
            await dispatch({ type: 'MAX_THRESHOLD_CHANGE', value: session ? session.maxThreshold : 50000.00 })
            await dispatch({ type: 'PARTNER_PROMOTION_TEXT_CHANGE', value: session ? session.partnerPromotion : ""})
            if( session && session.products) {
                await addProducts(session.products)
            }
            if( session ) {
                await setDisableSelectItems(session.categorySetManual ? false : true)
            }

            await changePage(true, false);
        }

    // Do when data was change
     useEffect(() => {
         if ( errors ) {
            setCalculateRate(false);
            setForceValidate(false);
         } else {
            setRetryCalc(true);
         }

    }, [errors])
// Do when initial charge and product price was change
    useEffect(() => {
        recalculatePriceEnd();
    }, [initialCharge, productPrice])

    let addProducts = async(newProducts) => {
        let tempProducts = []
        await newProducts.map(el => {
            tempProducts = [...tempProducts, {
                name: el.name,
                price: convertPrice(el.price),
                quantity: el.quantity,
                type: el.category ? getTypeName(el.category) : '',
                amortization: el.category ? getAmortization(el.category) : '',
                image: el.image ? el.image : '',
                added: el.added
            }]
        })
        await dispatch( {type: 'SET_PRODUCTS', value:  tempProducts } )
        await setForceValidate(true);
        await wait(500);
    }

    // when product was update
    useEffect(() => {
        updateProduct();
    }, [products])

    let updateProduct = () => {
        if ( products.length > 0 ) {
            if ( activeContract != 'nowoczesny') {
                let min = getMinimumMonths(products)
                dispatch({ type: 'MIN_MONTH_CHANGE', value: min});
            }
        }
    }

    let recalculatePriceEnd = () => {
        let fn;
        switch ( initialCharge ) {
            case "0%":
                fn = percentageCalc( 0, productPrice);
                dispatch({ type: 'CHARGE_PRICE_CHANGE', value: convertPrice(fn.charge.toString())  + " zł" })                
                dispatch({ type: 'PRODUCT_PRICE_END_CHANGE', value: convertPrice(repurchase.toString())  + " zł" })
                break;

            case "5%":
                fn = percentageCalc( 0.05, productPrice);
                dispatch({ type: 'CHARGE_PRICE_CHANGE', value: convertPrice(fn.charge.toString())  + " zł" })                
                dispatch({ type: 'PRODUCT_PRICE_END_CHANGE', value: convertPrice(repurchase.toString())  + " zł" })
                break;

            case "10%":
                fn = percentageCalc( 0.1, productPrice);
                dispatch({ type: 'CHARGE_PRICE_CHANGE', value: convertPrice(fn.charge.toString())  + " zł" })                
                dispatch({ type: 'PRODUCT_PRICE_END_CHANGE', value: convertPrice(repurchase.toString())  + " zł" })
                break;

            case "15%":
                fn = percentageCalc( 0.15, productPrice);
                dispatch({ type: 'CHARGE_PRICE_CHANGE', value: convertPrice(fn.charge.toString())  + " zł" })                
                dispatch({ type: 'PRODUCT_PRICE_END_CHANGE', value: convertPrice(repurchase.toString())  + " zł" })
                break;
            
            case "20%":
                fn = percentageCalc( 0.2, productPrice);
                dispatch({ type: 'CHARGE_PRICE_CHANGE', value: convertPrice(fn.charge.toString())  + " zł" })                
                dispatch({ type: 'PRODUCT_PRICE_END_CHANGE', value: convertPrice(repurchase.toString())  + " zł" })
                break;

            case "25%":
                fn = percentageCalc( 0.25, productPrice);
                dispatch({ type: 'CHARGE_PRICE_CHANGE', value: convertPrice(fn.charge.toString())  + " zł" })                
                dispatch({ type: 'PRODUCT_PRICE_END_CHANGE', value: convertPrice(repurchase.toString())  + " zł" })
                break;

            case "30%":
                fn = percentageCalc( 0.3, productPrice);
                dispatch({ type: 'CHARGE_PRICE_CHANGE', value: convertPrice(fn.charge.toString())  + " zł" })                
                dispatch({ type: 'PRODUCT_PRICE_END_CHANGE', value: convertPrice(repurchase.toString())  + " zł" })
                break;

            default:
            break;
        }
    }

    useEffect(() => {
        recalculatePriceEnd();
    }, [repurchase])

    // Do when data was change
    useEffect(() => {
        setForceValidate(false)
        setChangesInCalculator(true);
        recalculateRates();
    }, [fileData, productPrice, activeContract, initialCharge, leasingTime])

    // Do when click submit button
    // useEffect(() => {
       
    //     const checkForm = async () => {
    //         if ( calculateRate ) { 
    //             await setForceValidate(true);
    //             await wait(500);
    //             let scroll = await scrollPage();
    //             if ( scroll ) {
    //                 await setErrors(true);
    //             } else {
    //                 await setErrors(false);
    //                 await window.scroll({
    //                     behavior: 'smooth',
    //                     left: 0,
    //                     top: (activeContract === 'tradycyjny' ? document.querySelector('.price-end').offsetTop - 145 : document.querySelector('.leasing-rate-box').offsetTop - 185)
    //                 });
    //             }
    //         } else {
    //             await setErrors(true);
    //         }
    //       };
    //       checkForm();
        
    // }, [clickedButton])
    
    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
      }
    let scrollPage = () => {
        let result;
        let elements = document.querySelectorAll('.error-item');
        if( elements.length > 0 ) {
            let topElement = elements[0].getBoundingClientRect().top;
            let windowScroll = window.scrollY;
            window.scroll({
                behavior: 'smooth',
                left: 0,
                // top: elements[0].offsetTop - 85
                top: windowScroll + topElement - 140
              });
            result = true;
        } else {
            result = false;
        }
        return result;
        
    }

    let recalculateRates = () => {
        let valuePrice = productPrice;
            valuePrice = valuePrice.replace(/ /g,'');
            valuePrice = valuePrice.replace('zł', '');
            valuePrice = valuePrice.replace(',','.');
        
        let valueTax = tax;
            valueTax = valueTax.replace(/ /g,'');
            valueTax = valueTax.replace('zł', '');
            valueTax = valueTax.replace(',','.');

        let valueInitial = initialCharge;
            valueInitial = valueInitial.replace(/ /g,'');
            valueInitial = valueInitial.replace('zł', '');
            valueInitial = valueInitial.replace(',','.');
            valueInitial = valueInitial.replace('%','');

        let req = new XMLHttpRequest();
        let data = {
            "type": activeContract,
            "value": valuePrice,
            "price": valueTax,
            "initial": valueInitial,
            "months": leasingTime,
            "products": products
        }
        
        // if ( window.AppConfig  ) {
            if ( (window.AppConfig || window.location.hostname === 'localhost') && parseInt(productPrice) > 0) {
            // let url = window.AppConfig ? window.AppConfig.urlCalculate : '';
            let url = window.AppConfig ? window.AppConfig.urlCalculate : `${ getApiLink() }/calculate.php`;
            req.open('POST', url );
            req.setRequestHeader("Content-Type", "application/json;charset=UTF-8"); 
            req.send(JSON.stringify(data));
            
            req.addEventListener("readystatechange", async function () {
              if (this.readyState === 4) {
                    let resp = JSON.parse(req.response);
                    if ( resp != 'error') {
                        if ( resp.result.month == '--' || resp.result.quater == '--' ) {
                            dispatch({ type: 'TAX_CHANGE', value: '0,00 zł'})
                            setRate12('0,00 zł');
                            setRate4('0,00 zł');
                            dispatch({ type: 'REPURCHASE_CHANGE', value: 0.00 }); 
                        } else {
                            if(resp.result.price) {
                                dispatch({ type: 'TAX_CHANGE', value: convertPrice(resp.result.price.toFixed(2) ) + " zł" })
                            }
                            setRate12(resp.result.month);
                            setRate4(resp.result.quater);
                            dispatch({ type: 'REPURCHASE_CHANGE', value: parseFloat(resp.result.repurchase).toFixed(2) });              
                        }
                        
                    }
                }
            });
        }
        
    }

    let changePage = async (status = false, resetCalcInput = false) => {
        // console.log('run')
        // props.history.push('/krok/2')
        if(resetCalcInput) {
            setResetEmailCalc(++resetEmailCalc)
        }
        await setClickedButton(clickedButton + 1);
        await setForceValidate(true);
        await wait(500);
        let scroll = await scrollPage();
        if ( scroll ) {
            await setErrors(true);
        } else {
            if(!status) {
                props.history.push('/krok/2')
            }
        }
    }

    return (
        <>
            <MainBanner />
            <StepBar />
            <section className="calculator-form shop" id="calculator">
                <div className="container">
                    <div className="row" >
                    <LeasingItems  data={ fileData[0].tables }
                                      recalculateRates={ () => recalculateRates() }
                                      updateProducts={ () => updateProduct() }
                                      forceValidate={ forceValidate } 
                                      disableSelect={ disableSelectItems }
                                      forceValidateItems={ forceValidateItems }
                                      setForceValidateItems={ (val) => setForceValidateItems(val) } 
                                      clickedButton={ clickedButton } 
                                      price4={ rate4 }
                                      price12={ rate12 } 
                                      setUpdateType={ () => setUpdateType(updateType + 1) } />
                        
                        <div className="cols">
                            <div className="col">
                                {/* { provider &&  */}
                                    <ProviderInfo forceValidate={ forceValidate } zip={(fileData[0].seller.zipcode ? fileData[0].seller.zipcode.ans.val : '')} name={(fileData[0].seller.name ? fileData[0].seller.name.ans.val : '')}/>
                                {/* } */}
                                <TypeOfContract productPrice={ productPrice } 
                                                setCalculateRate={ async (val) => { await setCalculateRate(val); await setChangesInCalculator(false) } } 
                                                setClickedButton={(val) => setClickedButton(val)}
                                                clickedButton={ clickedButton } 
                                                retryCalc={retryCalc} 
                                                changesInCalculator={changesInCalculator}
                                                minimumMonth={ minimumMonth } />
                            </div>
                            <div className="col">
                                {/* { !ch?angesInCalculator && !errors && */}
                                    <LeasingRate activeRate4={ activeRate4 } 
                                                // activeContract={ activeContract }
                                                activeContract={ (activeContract == 'tradycyjny' ? 1 : 2) }
                                                calculateRate={ calculateRate } 
                                                rate4={ rate4 }
                                                rate12={ rate12 } 
                                                changePage={ () => { changePage(false, true); console.log('leasingrate') } } 
                                                forceValidate={ forceValidate } />
                                {/* } */}
                            </div>
                        </div>
                        < Benefits />
                        < LineSeperator />
                        < SendEmailCalc rate4={ rate4 }
                                        rate12={ rate12 } 
                                        resetEmailInput={resetEmailCalc}
                                        changePage={ (status) => { changePage(status); console.log('sendemailcalc') } }/>

                    </div>
                </div>
            </section>
        </>
    )
}

export default ShopHomePageContainer;